var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgApplyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 12,
    viewBox: "0 0 19 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.9998 0.3L6.38604 9.6L2.61985 6.3C2.16334 5.9 1.47858 5.9 1.02207 6.3C0.56556 6.7 0.56556 7.3 1.02207 7.7L5.58715 11.7C5.8154 11.9 6.04366 12 6.38604 12C6.72842 12 6.95667 11.9 7.18493 11.7L18.5976 1.7C19.0541 1.3 19.0541 0.7 18.5976 0.3C18.1411 -0.1 17.4564 -0.1 16.9998 0.3Z",
    fill: "#6366F1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApplyIcon);
export default __webpack_public_path__ + "static/media/applyIcon.1a66051b34d4a158ddd51e86e6b5825a.svg";
export { ForwardRef as ReactComponent };